import { FC, useState, useEffect, useContext } from 'react';

import RequestFormContainer from './RequestFormContainer';
import { IntlContext } from '../../IntlContext';

import './styles.scss';

type LeadformPropsTypes = {
  token: string;
  language?: string;
  isOpen?: boolean;
};

const Leadform: FC<LeadformPropsTypes> = ({ token, language, isOpen = false }) => {
  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);
  const [isShowLeadform, setIsShowLeadform] = useState<boolean>(true);

  const [currentToken, setCurrentToken] = useState<string>(token);
  const { setLocale } = useContext(IntlContext);

  useEffect(() => {
    if (language) {
      setLocale(language);
    }
  }, [language]);

  // handle global function visible form
  window.visibleLeadform = (visible: boolean) => {
    setIsShowLeadform(visible);
  };
  // handle global function update form
  window.updateUserContactLeadForm = ({ token: updateToken }) => {
    setCurrentToken(updateToken);
    setIsShowLeadform(true);
  };

  return (
    isShowLeadform && (
      <div className="clf-contact-form">
        <div
          className="clf-contact-form__icon-wrapper drop-shadow-medium"
          onClick={() => setIsShowPopup(!isShowPopup)}
        >
          <i
            className={
              isShowPopup ? 'clf-icon-menu_close_big_24x24' : 'clf-icon-communication_support_24x24'
            }
          />
        </div>
        <RequestFormContainer
          token={currentToken}
          isShow={isShowPopup}
          onClose={() => {
            setIsShowPopup(false);
          }}
        />
      </div>
    )
  );
};

export default Leadform;
